<div class="all-my-lots-container"
     data-testid="all-my-lots-container">

  <div class="online-header"
       data-testid="cm-header-online">
    <div class="title"
         data-testid="cm-text-all-my-lots-title">All My Lots</div>
    <div class="icon-container">
      <app-svg-search-button data-testid="cm-btn-search"
                             (buttonClick)="showIndicatorBottomSheet()"></app-svg-search-button>
      <online-indicator></online-indicator>
    </div>
  </div>
  <app-background-refresh-indicator [active]="isRefreshingInBackground()" />

  <div class="community-tab-content"
       [appDataUpdatedFade]="dataUpdatedPulse()"
       data-testid="cm-container-community-tabs">
    <p-tabs [value]="selectedIndex"
            (valueChange)="onTabChange($event)"
            [scrollable]="true"
            [showNavigators]="true"
            class="tab-container"
            data-testid="all-my-lots-tabs">
      <p-tablist data-testid="cm-list-tabs"
                 (wheel)="onTabRowWheel($event)">
        @for (t of tabList; track t.tabIndex) {
          <p-tab [value]="t.tabIndex"
                 [attr.data-testid]="'cm-tab-community-' + t.tabIndex">
            <div #tabEl
                 (click)="focusTab(tabEl)">
              {{ t.title }}
            </div>
          </p-tab>
        }
        @if(tabList.length === 0) {
          <div class="tab-loader">
            <p-skeleton width="6rem"
                        height="1.5rem"></p-skeleton>
            <p-skeleton width="6rem"
                        height="1.5rem"></p-skeleton>
            <p-skeleton width="6rem"
                        height="1.5rem"></p-skeleton>
            <p-skeleton width="6rem"
                        height="1.5rem"></p-skeleton>
          </div>
        }
      </p-tablist>
      @if (tabList.length === 0) {
        <div class="loader">
          <p-skeleton height="6rem"></p-skeleton>
          <p-skeleton height="6rem"></p-skeleton>
          <p-skeleton height="6rem"></p-skeleton>
        </div>
      }
      <p-tabpanels class="tab-panels"
                   data-testid="cm-container-tab-panels">
        @for (t of tabList; track t.tabIndex) {
          <p-tabpanel [value]="t.tabIndex"
                      [attr.data-testid]="'cm-tabpanel-community-' + t.tabIndex">
            @for (lot of t.lots; track lot.id) {
              <div class="lot-highlight-wrapper"
                   [attr.data-testid]="'cm-item-lot-' + lot.id"
                   [class.new-lot-pulse]="isNewlyAddedLot(t.tabIndex, lot.id)">
                <app-lot-card [lotItem]="lot"
                              [communityId]="t.tabIndex"
                              [lotPrimaryIdentifier]="lotPrimaryIdentifier"
                              (archiveRequested)="onArchiveLot($event)">
                </app-lot-card>
              </div>
            }
          </p-tabpanel>
        }
      </p-tabpanels>
    </p-tabs>
  </div>

  <app-bottom-sheet [(isOpen)]="isBottomSheetOpen"
                    [contentTemplate]="searchTemplate"
                    [preventOverlayClose]="false"
                    [hasFooter]="false"
                    [isFullScreen]="isSearchFullScreen"
                    data-testid="cm-drawer-search"
                    [backgroundClass]="'cm-search-sheet'" />
</div>

<ng-template #searchTemplate>
  <cm-lot-search-drawer data-testid="cm-drawer-lot-search"
                        (onSheetClose)="closeSearchSheet()"
                        (sheetModeChange)="onSheetModeChange($event)">
  </cm-lot-search-drawer>
</ng-template>